var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"footer"},[_c('td',[_vm._v(" © 2003-2013 Latitude Technologies, Inc. All Rights Reserved. ")])])}]

export { render, staticRenderFns }